import { Form, Input, InputNumber, Switch } from 'antd';
import React, { useEffect, useRef } from 'react';
import AntDraggableModal from '../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../system/WebEditUniversalNewEx'

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const DisCountEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    /** 后端数据wmService */
    let wmService: any = "";
    const ref = useRef<any>(undefined);





    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'disCount',
    };
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        const fetchData = async () => {

        };
        fetchData();
    }, []);
    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '品牌'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                   onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Form.Item
                        label="id"
                        name="id">
                        <Input disabled={true} />
                    </Form.Item>


                    <Form.Item
                        label="折扣名称"
                        name="disCountName"
                        rules={[{ required: true, message: '请输入折扣名称!' }]}>
                        <Input />
                    </Form.Item>

            


                    <Form.Item
                        label="折扣"
                        name="disCount"
                        rules={[{ required: true, message: '请输入折扣!' }]}
                        >
                            
                        <InputNumber
                         max={1}
                         step={0.1}
                        precision={2}
                        />
                    </Form.Item>

                    {/* <Form.Item
                        label="预定状态"
                        name="reserveStatus"
                        rules={[{ message: '请选择状态!', required: false }]}>
                        <Select
                            showSearch
                            placeholder="选择状态"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(reserveStatusData, 'name')}
                        </Select>
                    </Form.Item> */}

                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>


                </Form>
            </AntDraggableModal>
        </>
    )
}

export default DisCountEdit;